import { render, staticRenderFns } from "./PaginatorList.vue?vue&type=template&id=e9176ab0&scoped=true"
import script from "./PaginatorList.vue?vue&type=script&lang=js"
export * from "./PaginatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9176ab0",
  null
  
)

export default component.exports